/* eslint-disable no-param-reassign */
/* eslint-disable prefer-const */
/* eslint-disable no-continue */
/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-explicit-any */
import IconClose from '@assets/icons/close.svg?react';
import {
 Box,
 Card,
 CardContent,
 IconButton,
 Typography,
 useTheme,
} from '@mui/material';
import { Dispatch, MutableRefObject, SetStateAction } from 'react';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CustomGridApi } from '../XTable/types';
import FilterFields from './FilterFields';
import useFilterSidebar from './useFilterSidebar';

interface FilterSidebarProps {
 apiRef: MutableRefObject<CustomGridApi>;
 isOpen: boolean;
 handleClose: Dispatch<SetStateAction<boolean>>;
 setColModalOpen: Dispatch<SetStateAction<boolean>>;
}

const FilterSidebar = (props: FilterSidebarProps) => {
 const { t } = useTranslation();
 const th = useTheme();
 const { apiRef, isOpen, handleClose, setColModalOpen } = props;

 const {
  applyFilters,
  resetFilters,
  methods,
  columns,
  dateRangeColumns,
  currentColumnsPreset,
  structure,
  isFormChanged,
 } = useFilterSidebar({ apiRef });

 return !isOpen ? null : (
  <Box
   sx={{
    width: isOpen ? { xs: '100%', md: '320px' } : '0px',
    transition: 'all 0.2s ease-in-out',
    marginLeft: isOpen ? { xs: '0px', md: '16px' } : '0px',
    overflowY: 'auto',
    position: 'relative',
   }}
  >
   <Card sx={{ height: '100%' }}>
    <CardContent
     sx={{
      p: 0,
      fontSize: '12px',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
     }}
    >
     <Box
      sx={{
       display: 'flex',
       alignItems: 'center',
       justifyContent: 'space-between',
       py: '20px',
       width: '100%',
       px: 3,
      }}
     >
      <Typography
       sx={{
        fontSize: { xs: 14, md: 16 },
        fontWeight: 500,
        lineheight: 'initial',
       }}
      >
       {t('global.filters')}
      </Typography>
      <IconButton
       onClick={() => handleClose(false)}
       sx={{
        position: 'relative',
        p: 0,
        top: { xs: 0, md: -8 },
        right: { xs: 0, md: -8 },
       }}
      >
       <IconClose
        style={{ width: 20, height: 20, color: th.palette.kemek.darkestGray }}
       />
      </IconButton>
     </Box>
     <FormProvider {...methods}>
      <FilterFields
       apiRef={apiRef}
       applyFilters={applyFilters}
       resetFilters={resetFilters}
       setColModalOpen={setColModalOpen}
       columns={columns}
       dateRangeColumns={dateRangeColumns}
       currentColumnsPreset={currentColumnsPreset}
       structure={structure}
       isFormChanged={isFormChanged}
      />
     </FormProvider>
    </CardContent>
   </Card>
  </Box>
 );
};
export default FilterSidebar;
